// extracted by mini-css-extract-plugin
export default {"primary":"#000","primaryBg":"#23174f","borderShadow":"rgba(137,42,236,.25)"};